export default __webpack_public_path__ + "static/media/07.98b01c48.jpg";